import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { FilterValue } from 'src/app/models/filter-value';
import { LocaleService } from 'src/app/services/locale.service';
import { Filter } from '../../models/filter';
import { Util } from '../../util';
import { OtkList, ViewAllValuesDialogData } from '../../models/user-item-list';
import { ThemaService } from '../../services/thema.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-view-all-values-dialog',
  templateUrl: './view-all-values-dialog.component.html',
  styleUrls: ['./view-all-values-dialog.component.scss'],
})
export class ViewAllValuesDialogComponent {
  filter: Filter;
  lists: OtkList[];
  listIds: number[];
  values: FilterValue[];
  filteredValues: Array<FilterValue | OtkList>;
  typeToFilterLabel: string;
  themaList: boolean;
  fetching: boolean;

  // Paginator configuration
  paginatorLength: number;
  pageSize: number;
  pageSizeOptions: number[];

  constructor(
    public dialogRef: MatDialogRef<ViewAllValuesDialogComponent>,
    private localeService: LocaleService,
    private themaService: ThemaService,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: ViewAllValuesDialogData
  ) {
    this.filter = data.filter;
    this.values = data.filter.values;
    if (this.data.paginatedLists) {
      this.lists = data.paginatedLists.items;
    }
    if (this.data.listIds) {
      this.listIds = data.listIds;
    }
    this.filteredValues = this.getPreFilteredValues();

    if (this.data.paginatedLists) {
      this.pageSize = this.data.paginatedLists.itemsPerPage;
      this.paginatorLength = this.data.paginatedLists.itemsTotal;
      this.pageSizeOptions = [this.data.paginatedLists.itemsPerPage, 24, 48];
    }

    this.fetching = false;

    localeService.getString('general.typeToFilter').subscribe((value) => (this.typeToFilterLabel = value));
  }

  doFilter(search: string) {
    this.filteredValues = this.getPreFilteredValues(search);
  }

  adaptAndTranslate(value: FilterValue): string {
    if (Util.LANGUAGE_FILTERS.includes(this.filter.name) && value.name.length === 3) {
      return this.localeService.instant(`languages.${value.name}`, {default: value.name});
    }
    if (Util.SUBJECT_FILTER.includes(this.filter.name)) {
      return this.localeService.instant(`subjects.${Util.formatSubject(value.name)}`, {default: value.name});
    }
    if (Util.THEMA_FILTER.includes(this.filter.name)) {
      return this.themaService.getDescription(value.name);
    }
    if (Util.FORMAT_FILTER.includes(this.filter.name)) {
      return this.localeService.instant(`formats.${value.name}`, {default: value.name});
    }
    if (this.filter.name === 'biblioHO') {
      return value.nameBiblio;
    }
    if ((Util.COLLECTION_FILTER.includes(this.filter.name) || Util.PUBLIC_FILTER.includes(this.filter.name)) && value.nameToShow) {
      return value.nameToShow;
    }

    return value.name;
  }

  pageChangeHandler(event: PageEvent) {
    this.fetching = true;
    const offset = event.pageIndex * event.pageSize;
    this.apiService.getPublicLists(this.listIds, event.pageSize, offset).subscribe((paginatedResult) => {
      this.lists = paginatedResult.items;
      this.paginatorLength = paginatedResult.itemsTotal;
      this.pageSize = paginatedResult.itemsPerPage;
      this.filteredValues = this.getPreFilteredValues();
      this.fetching = false;
    });
  }

  private getPreFilteredValues(search?: string): Array<OtkList | FilterValue> {
    if (Util.THEMA_FILTER === this.filter.name) {
      this.themaList = true;
      return this.themaService.groupFilter(this.filter, search);
    }
    if (this.lists) {
      this.themaList = false;
      return this.lists.filter(filter => !search || filter.name.toLowerCase().includes(search.toLowerCase()));
    }
    if (this.values) {
      this.themaList = false;
      const filtered = this.values.filter(filter => !search || filter.nameToShow.toLowerCase().includes(search.toLowerCase()));
      if (filtered.length === 0) {
        return this.values.filter(filter => !search || filter.nameBiblio.toLowerCase().includes(search.toLowerCase()));
      }
      return filtered;
    }
  }
}
